import React, { useEffect } from 'react'
import { codeleapWebCache } from '@codeleap/web'
import { CacheProvider } from '@emotion/react'
import { Root } from './src/Root'
import { AppStatus } from './src/redux'
import { PermissionUtils, useFirebaseUser } from './src/utils'
import { APIClient } from './src/services'
import { Redirect } from './src/components'
import { WrapPageElementBrowserArgs } from 'gatsby'

import { initAnalytics, analytics } from './src/services/analytics'
import { createLog } from './src/utils/utility'

const DEBUG = false
const log = createLog('gatsby-browser', DEBUG)

export const wrapRootElement = ({ element }) => {
  log('wrapRootElement')
  return (
    <CacheProvider value={codeleapWebCache}>
      <Root>{element}</Root>
    </CacheProvider>
  )
}

const ShowAppStatus = () => {
  log('ShowAppStatus rendered')
  useEffect(() => {
    log('ShowAppStatus useEffect')
    AppStatus.set('splash')
    return () => {
      log('ShowAppStatus cleanup')
      AppStatus.set('idle')
    }
  }, [])

  return null
}

export const wrapPageElement = ({ element, props }: WrapPageElementBrowserArgs) => {
  const isRoutePublic = PermissionUtils.isRoutePublic(props.location.pathname)
  log('isRoutePublic', isRoutePublic)

  const firebase = useFirebaseUser()
  const user = APIClient.Session.useProfile()

  if (isRoutePublic) return element

  const loadingVars = [user.isLoading]
  log('loadingVars', loadingVars)

  const loading = loadingVars.some(Boolean)

  if (loading || firebase.isLoading) {
    log('loading')
    return <ShowAppStatus />
  }

  log({ firebaseUser: firebase.firebaseUser, user: user.data })
  const hasUser = [firebase.firebaseUser?.uid, user.data?.id].every(Boolean)
  log('hasUser', hasUser)

  if (!hasUser) {
    return <Redirect to='/auth/login' />
  }

  return element
}

export const onClientEntry = async () => {
  log('onClientEntry')
  await initAnalytics()

  analytics.page()
}

export const onRouteUpdate = ({ location }) => {
  log('onRouteUpdate', location.pathname)
  analytics.page({
    path: location.pathname,
    url: location.href,
  })
}
